import React from "react";
import { Chip, Paper, Typography } from "@mui/material";

// NOTIF-24 — inbox-row preview beside `message`: updates per keystroke and
// reflects the selected `category`. Memoized on its own {message, category}
// slice (context.md "Previews") so unrelated field edits elsewhere in
// ContentStep don't force it to re-render.
function InboxPreview({ message, category }) {
  return (
    <Paper
      variant="outlined"
      data-testid="inbox-preview"
      sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1, minWidth: 240 }}
    >
      <Typography variant="caption" color="text.secondary">
        Inbox preview
      </Typography>
      <Chip
        label={category}
        size="small"
        data-testid="inbox-preview-category"
        sx={{ alignSelf: "flex-start" }}
      />
      <Typography variant="body2" data-testid="inbox-preview-message" sx={{ wordBreak: "break-word" }}>
        {message}
      </Typography>
    </Paper>
  );
}

export default React.memo(InboxPreview);
